import React, { useEffect, useRef, useState } from 'react'
import { IoCheckmarkDoneCircle } from 'react-icons/io5'

function WeekdaySelector({
  Values = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ],
  title = 'select Days Week',
  name,
  onChange,
  AdditionalStyle,
  multiple = true,
}) {
  const [selectedDays, setSelectedDays] = useState([])
  const [selectedText, setSelectedText] = useState('')
  const [showSelect, setShowSelect] = useState(false)
  const wrapperRef = useRef(null)

  const toggleDaySelection = (day) => {
    if (multiple) {
      if (selectedDays.includes(day)) {
        setSelectedDays(
          selectedDays.filter((selectedDay) => selectedDay !== day)
        )
        onChange({
          target: {
            name,
            value: selectedDays.filter((selectedDay) => selectedDay !== day),
          },
        })
        setSelectedText(
          selectedDays.filter((selectedDay) => selectedDay !== day).join(', ')
        )
      } else {
        setSelectedText([...selectedDays, day].join(', '))
        setSelectedDays([...selectedDays, day])
        onChange({ target: { name, value: [...selectedDays, day] } })
      }
    } else {
      setSelectedDays(day)
      setSelectedText(day)
      onChange({
        target: {
          name,
          value: day,
        },
      })
    }
  }

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSelect(false)
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])
  return (
    <div className={`select selectDay ${AdditionalStyle} col-span-2`}>
      <div
        onClick={() => setShowSelect(true)}
        className='w-100 selectDayHeader bg-white border'
      >
        {selectedText ? selectedText : title}
      </div>
      {showSelect && (
        <>
          <div className='daysContainer' ref={wrapperRef}>
            {Values.map((day) => (
              <div
                className='dAY'
                key={day}
                onClick={() => toggleDaySelection(day)}
                style={{
                  backgroundColor: selectedDays.includes(day)
                    ? '#59c50f42'
                    : '#008dcf56',
                  marginRight: '2px',
                }}
              >
                {day}
              </div>
            ))}
            <div
              className='dAY'
              style={{
                color: '#59c50f',
                fontSize: 28,
                gridColumnStart: 1,
                gridColumnEnd: 3,
              }}
              onClick={() => setShowSelect(false)}
            >
              <IoCheckmarkDoneCircle />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default WeekdaySelector
